import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

const themes = [
  { id: 'sage', name: 'Salvia', accent: 'hsl(144, 18%, 56%)' },
  { id: 'terracotta', name: 'Terracota', accent: 'hsl(16, 50%, 55%)' },
  { id: 'gold', name: 'Dorado', accent: 'hsl(43, 60%, 50%)' },
];

export function ThemeProvider({ children }) {
  const [currentTheme, setCurrentTheme] = useState('sage');
  
  useEffect(() => {
    // Remove all theme classes first
    document.documentElement.classList.remove('theme-sage', 'theme-terracotta', 'theme-gold');
    // Add current theme class
    document.documentElement.classList.add(`theme-${currentTheme}`);
  }, [currentTheme]);
  
  const cycleTheme = () => {
    const currentIndex = themes.findIndex(t => t.id === currentTheme);
    const nextIndex = (currentIndex + 1) % themes.length;
    setCurrentTheme(themes[nextIndex].id);
  };
  
  return (
    <ThemeContext.Provider value={{
      currentTheme,
      setCurrentTheme,
      cycleTheme,
      themes,
      currentThemeData: themes.find(t => t.id === currentTheme),
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
